import {Component} from "@angular/core";

@Component({
    selector: "otcx-home-publications",
    templateUrl: "./home-publications.component.html",
    standalone: false
})
export class HomePublicationsComponent {
}
